import React from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Button, Chip } from '@material-ui/core';
import { TextField } from '@roc/ui';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: '100px',
  },
  tagInput: {
    borderRight: 'none',
    borderLeft: 'none',
    borderTop: 'none',
    borderRadius: 0,
  },
}));

interface TagManagerProps {
  store: any;
  formStore: any;
  details: any;
  isContactTag: boolean;
}

const SalesUserTag: React.FC<TagManagerProps> = ({ store, formStore, details, isContactTag }) => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={6} container>
        {details?.leadTags?.map((leadTag) => (
          <Chip
            key={leadTag.leadTagId}
            label={leadTag.tag}
            style={{ margin: 1 }}
            color="primary"
            onDelete={() => isContactTag ? store.deleteContactTag(leadTag.contactTagId) : store.deleteTag(leadTag.leadTagId)}
          />
        ))}
      </Grid>
      <Grid item container xs={6} direction="row-reverse">
        <Grid item>
          <Button
            className={classes.button}
            variant="contained"
            size="small"
            onClick={() => isContactTag ? store.saveContactTag() : store.saveTag()}
            color="primary"
            data-testid="addTag"
          >
            Add Tag
          </Button>
        </Grid>
        <Grid item>
          <TextField
            variant="standard"
            testId="addSalesUserTag"
            className={classes.tagInput}
            value={formStore.form.fields?.leadTag?.value || ''}
            onChange={(e) => formStore.onFieldChange('leadTag', e.target.value)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default observer(SalesUserTag);
